export default class ClientGroupModel {
  cnpj!: string;

  codCliente!: string;

  nomeCliente!: string;
}
